// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "clear-12akA";
export { _1 as "__esModule", _2 as "clear" }
export default { "__esModule": _1, "clear": _2 }
